export default __webpack_public_path__ + "static/media/10_2.c65cc81b.jpg";